<template>
	<div v-loading="loading" class="main-content">
		<div class="main-content-inner">
			<div v-if="!loading" class="container-fluid">
				<div class="row">
					<div class="col-lg-12">
						<div class="content margin-bottom-30">
							<div class="content-header">
								<h2>
									Applications ({{ total }})
								</h2>
							</div>
							<div v-loading="loading" class="content-body">
								<el-table :data="tableData" :default-sort="{ prop: 'created_at', order: 'descending' }" style="width: 100%">
									<el-table-column label="Date" prop="created_at" width="180">
										<template slot-scope="scope">
											{{ scope.row.created_at | convertDateTime }}
										</template>
									</el-table-column>
									<el-table-column label="Name" prop="first_name">
										<template slot-scope="scope">
											{{ scope.row.first_name }} {{ scope.row.last_name }}
										</template>
									</el-table-column>
									<el-table-column label="Email" prop="email"></el-table-column>
									<el-table-column label="Status" prop="status" width="160">
										<template slot-scope="scope">
											<el-tag :type="convertApplicationStatus(scope.row.status)" size="small">
												{{ scope.row.status }}
											</el-tag>
										</template>
									</el-table-column>
									<el-table-column align="right" width="80">
										<template slot-scope="scope">
											<el-button size="mini" type="primary" plain circle icon="el-icon-chat-line-round" @click="handleView(scope.row.id)"></el-button>
										</template>
									</el-table-column>
								</el-table>
								<div v-if="total > pageSize" style="margin-top: 20px; text-align: right;">
									<el-pagination
										:total="total"
										:current-page.sync="currentPage"
										@current-change="handlePageChange"
										@prev-click="loadData(prevPage)"
										@next-click="loadData(nextPage)"
										layout="prev, pager, next"
										background
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { HTTP } from '@/services/api'

export default {
	name: 'ApplicationsList',
	metaInfo () {
		return {
			title: 'Applications',
		}
	},
	components: {
	},
	data () {
        return {
			loading: true,
			tableData: [],
			total: null,
			pageSize: null,
			prevPage: null,
			nextPage: null,
			currentPage: null,
        }
    },
	computed: {
        ...mapState(['user'])
	},
	mounted () {
		this.loadData()
	},
	methods: {
		loadData (url) {
			this.loading = true
			let path = url !== undefined ? url : '/loan-applications?page=1'
			HTTP({
				method: 'GET',
				url: path,
				crossdomain: true
			})
			.then(response => {
				this.tableData = response.data.data
				this.total = response.data.total
				this.pageSize = response.data.per_page
				this.prevPage = response.data.prev_page_url
				this.nextPage = response.data.next_page_url
				this.currentPage = response.data.current_page
				this.loading = false
			})
			.catch(error => {
				this.loading = false
				this.$notify({
					title: 'Error',
					message: error.response.data.status ? error.response.data.status : 'An error occured, please try later',
					type: 'error',
					position: 'bottom-right',
					duration: 3500
				})
			})
		},
		handlePageChange (page) {
			this.loadData('/loan-applications?page=' + page)
		},
		handleView (id) {
			this.$router.push('/applications/' + id)
		},
		convertApplicationStatus (value) {
			if (value) {
				if (['accepted'].includes(value)) {
					return 'success'
				}
				else if (['pending'].includes(value)) {
					return 'info'
				}
				else if (value === 'started') {
					return 'warning'
				}
				else if (['duplicate', 'validation_error', 'technical_error', 'rejected'].includes(value)) {
					return 'danger'
				}
				else {
					return ''
				}
			}
		}
	}
}
</script>
